<script lang="ts" context="module">
  import type { PasswordStrength } from "./passwordValidations";
</script>

<script lang="ts">
  export let passwordStrength: PasswordStrength;
</script>

<span class="font-medium">Must include at least:</span>
<!--
  Icon names are a single updated text node and marked translate="no": Chrome's page translation
  replaces text nodes, and the old {#if}check_circle{:else}...{/if} blocks then crashed detaching the
  orphaned node ("Cannot read properties of null (reading 'removeChild')", Sentry SMORE-FRONTEND-93Z1).
-->
<ul class="ml-2 text-nxgray-600">
  <li class:text-success-700={passwordStrength.hasLength} class="flex items-center transition-colors">
    <span translate="no" class="material-icons mr-1" style="font-size: 13px !important">
      {passwordStrength.hasLength ? "check_circle" : "radio_button_unchecked"}
    </span>
    8 characters
  </li>
  <li class="flex items-center transition-colors" class:text-success-700={passwordStrength.hasLowerAndUpper}>
    <span translate="no" class="material-icons mr-1" style="font-size: 13px !important;">
      {passwordStrength.hasLowerAndUpper ? "check_circle" : "radio_button_unchecked"}
    </span>
    Upper & lower case letter
  </li>
  <li class:text-success-700={passwordStrength.hasNumberAndSymbol} class="flex items-center transition-colors">
    <span translate="no" class="material-icons mr-1 transition-transform" style="font-size: 13px !important;">
      {passwordStrength.hasNumberAndSymbol ? "check_circle" : "radio_button_unchecked"}
    </span>
    Number & special character (i.e $#%)
  </li>
</ul>
